import { useState } from "react";

export interface IEditMode {
  value: boolean;
  handleEditClick: () => void;
  handleCancelClick: () => void;
}

export const useEditMode = (initialEditMode?: boolean): IEditMode => {
  const [editMode, setEditMode] = useState(initialEditMode || false);

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleCancelClick = () => {
    setEditMode(false);
  };

  return {
    value: editMode,
    handleEditClick,
    handleCancelClick,
  };
};
